import { Button, Row } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCallback, useMemo, useState } from "react";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import { useDeleteHandler } from "./formHandlers/deleteHandler";
import { usePermissions } from "../../../../../../../lib/hooks/usePermissions";

export const useGetBankAccountsTableColumns = (
  onOpenSideBar: (value: any | null) => void,
  reload: () => void,
) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const { hasAccess } = usePermissions();

  const { onRemoveClicked } = useDeleteHandler();

  const onDelete = useCallback(
    (e: React.MouseEvent<HTMLSpanElement>) => {
      e.stopPropagation();
      const id = e.currentTarget.id;
      onRemoveClicked(id, setIsDisabled, reload);
    },
    [onRemoveClicked, reload],
  );

  const columns: ColumnsType<any> = useMemo(
    () => [
      {
        title: "Bank Account #",
        dataIndex: "bankAccountNumber",
        width: "22%",
        ellipsis: true,
      },
      {
        title: "Primary",
        dataIndex: "isPrimary",
        width: "60%",
        render: (value: boolean) => (value ? "Yes" : "No"),
      },
      {
        title: "",
        width: "18%",
        render: (_: unknown, record: any) => {
          return (
            <Row className="table-actions">
              {hasAccess("CustomersBankAccounts", "Modify") && (
                <Button
                  className="mr-4 px-0 py-0"
                  type="link"
                  onClick={() => onOpenSideBar(record)}
                  icon={<EditOutlined className="text-md title" />}
                  disabled={isDisabled}
                />
              )}
              {hasAccess("CustomersBankAccounts", "Delete") && (
                <Button
                  id={record.id}
                  className="px-0 py-0"
                  type="link"
                  onClick={onDelete}
                  icon={<CloseOutlined className="text-md title" />}
                  disabled={isDisabled}
                />
              )}
            </Row>
          );
        },
      },
    ],
    [isDisabled, onOpenSideBar, onDelete, hasAccess],
  );

  return { columns };
};
